import MnTable from './MnTable';

export default MnTable;
